import { useTranslation } from 'react-i18next'

import { DotsThreeCircleVerticalIcon, FileArrowDownIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomerNotesCardMenu = ({ onExport, disabled }) => {
  const { t } = useTranslation()

  return (
    <ButtonMenu
      menuItems={[
        {
          label: (
            <Styles.MenuOptionLabel>
              <FileArrowDownIcon />
              {t('Descargar CSV')}
            </Styles.MenuOptionLabel>
          ),
          onClick: onExport,
        },
      ]}
      renderButton={onOpen => (
        <IconButton
          onClick={onOpen}
          variant="text"
          disabled={disabled}
          icon={<DotsThreeCircleVerticalIcon data-testid="customer-notes-menu" size={24} />}
        />
      )}
    />
  )
}

export default CustomerNotesCardMenu
